const required = (k) => {
  const v = process.env[k];
  if (!v) throw new Error(`Missing env: ${k}`);
  return v;
};
const stripTrailingSlash = (s) => s.replace(/\/+$/, "");
const toNs = (ns) => (ns ? (ns.startsWith("/") ? ns : `/${ns}`) : "");

const RAW_SOCKET_URL = required("REACT_APP_SOCKET_URL");
const RAW_SOCKET_NS = process.env.REACT_APP_SOCKET_NS || "";
export const SOCKET_EVENT = process.env.REACT_APP_SOCKET_EVENT || "equity_data";

const RAW_FINALIST_API = required("REACT_APP_FINALIST_ACCOUNTS_URL");

export const RAW_REZA_BASE = required("REACT_APP_Server_BASE");

const RAW_TEAMS_BASE = required("REACT_APP_REZA_BASE");

const RAW_QB_SOCKET = process.env.REACT_APP_QUESTIONBROADCAST_SOCKET_URL || "";
const RAW_QB_TOKEN =
  process.env.REACT_APP_QUESTIONBROADCAST_TOKEN || "client_secret_token";

const SOCKET_BASE = stripTrailingSlash(RAW_SOCKET_URL);
const SOCKET_NS = toNs(RAW_SOCKET_NS);
const FINALIST_API_BASE = stripTrailingSlash(RAW_FINALIST_API);
const REZA_BASE = stripTrailingSlash(RAW_REZA_BASE);
const TEAMS_BASE = stripTrailingSlash(RAW_TEAMS_BASE);

export const QUESTION_BROADCAST_SOCKET_URL = RAW_QB_SOCKET
  ? stripTrailingSlash(RAW_QB_SOCKET)
  : "";
export const QUESTION_BROADCAST_TOKEN = RAW_QB_TOKEN;

export const SOCKET_URL = `${SOCKET_BASE}${SOCKET_NS}`;

export const API_ENDPOINT = {
  users: {
    getFinalistsData: `${FINALIST_API_BASE}/api/final/finalists`,
    getLeaderBoardData: `${FINALIST_API_BASE}/api/leaderboard?groups[]=next_level&stage=3`,
  },
  initalepercentage: {
    getInitialPercentage: `${TEAMS_BASE}/api/tournament/admin/stages/five-percent`,
  },
  time: {
    postCreateTime: `${REZA_BASE}/api/time/check`,
    postValidattion: `${REZA_BASE}/api/time/validate`,
    getNow: `${REZA_BASE}/api/time/now-plus-two`,
    getTest: `${REZA_BASE}/api/time/test?token=`,
  },
  wallQuestions: {
    getIndex: `${REZA_BASE}/api/quiz/admin/questions`,
    getShow: `${REZA_BASE}/api/quiz/wall/questions`,
    getAnswers: `${REZA_BASE}/api/quiz/wall/answers`,
    getResults: `${REZA_BASE}/api/quiz/wall/results`,
    getFinalShow: `${REZA_BASE}/api/quiz/wall/questions/final`,
    getUserBoard: `${REZA_BASE}/api/quiz/wall/questions/userBoard`,
    getResultByQuestion: (id) =>
      `${TEAMS_BASE}/api/quiz/wall/questions/${id}/results`,
  },
  operatorQuestions: {
    initiateQuestion: (id) =>
      `${REZA_BASE}/api/quiz/admin/questions/${id}/initiate`,
  },
  wallTransferMarket: {
    getIndex: `${REZA_BASE}/api/transfer-market/wall/totals`,
  },

  wallTeams: {
    getIndex: `${TEAMS_BASE}/api/teams/wall`,
    getShow: `${TEAMS_BASE}/api/teams/wall`,
    sabziTeams: `${TEAMS_BASE}/api/teams/wall/summary`,
  },
  wallPositions: {
    postGet: `${TEAMS_BASE}/api/teams/wall/positions/login/timeline`,
    postMargin: `${TEAMS_BASE}/api/admin/final/accounts/margin`,
    getEachUser: (id) =>
      `${TEAMS_BASE}/api/admin/final/accounts/user_details/${id}/leaderboard`,
  },
  adminTeams: {
    getIndex: `${TEAMS_BASE}/api/teams/admin`,
    getShow: `${TEAMS_BASE}/api/teams/admin`,
    postCreate: `${TEAMS_BASE}/api/teams/admin`,
    putUpdate: `${TEAMS_BASE}/api/teams/admin`,
    deleteTeam: `${TEAMS_BASE}/api/teams/admin`,
    putChangeCaptain: (id) =>
      `${TEAMS_BASE}/api/teams/admin/${id}/change-capitan`,
    postAddPointTransaction: (id) =>
      `${TEAMS_BASE}/api/teams/admin/${id}/add-point`,
    postAddTeamMember: (id) =>
      `${TEAMS_BASE}/api/teams/admin/${id}/add-team-member`,
  },
  userTeams: {
    getIndex: `${TEAMS_BASE}/api/teams/user`,
    getShow: `${TEAMS_BASE}/api/teams/user`,
  },
  finalists: {
    getListOfFinalists: `${TEAMS_BASE}/api/final/finalists`,
  },
};

if (process.env.NODE_ENV === "development") {
  console.log("[CONF]", {
    SOCKET_URL,
    SOCKET_EVENT,
    finalists: API_ENDPOINT.users.getFinalistsData,
    rezaBase: REZA_BASE,
    teamsBase: TEAMS_BASE,
    wallIndex: API_ENDPOINT.wallQuestions.getIndex,
    questionBroadcastSocket: QUESTION_BROADCAST_SOCKET_URL || "(missing)",
  });
}
